import React from 'react';
import gql from 'graphql-tag';
import { useApolloClient } from '@apollo/client';

export const MainAppContext = React.createContext();

const getMe = gql`
query Me {
	me {
		name
		surname
		id
		type
		accessLimitedTo
		actived
		roles
		phone
		email
		preferredLanguage
	}
}
`;

const MainApp = ({ children }) => {
	const [state, updateState] = React.useState({
		account: null,
		loading: false,
		wudder: null
	});
	const client = useApolloClient();
	const token = sessionStorage.getItem('token');

	const setUser = user => {
		updateState({
			...state,
			user
		});
	};

	const loginSuccess = async () => {
		const response = await client.query({
			query: getMe,
			errorPolicy: 'all'
		});

		updateState({
			...state,
			user: response.data.me,
		});
	};

	const logout = () => {
		sessionStorage.removeItem('token');
		sessionStorage.removeItem('refreshToken');
		sessionStorage.removeItem('account');
		updateState({
			account: null,
			user: null
		});
	};

	if (!state.user && token) {
		loginSuccess();
	}

	return (
		<MainAppContext.Provider value={{
			state,
			updateState,
			loginSuccess,
			client,
			logout,
			setUser
		}}>
			{children}
		</MainAppContext.Provider>
	);
};


export default MainApp;
